import { render, staticRenderFns } from "./WhatsappConfig.vue?vue&type=template&id=454fc366&scoped=true&lang=pug"
import script from "./WhatsappConfig.vue?vue&type=script&lang=js"
export * from "./WhatsappConfig.vue?vue&type=script&lang=js"
import style0 from "./WhatsappConfig.vue?vue&type=style&index=0&id=454fc366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454fc366",
  null
  
)

export default component.exports